// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___8P63","colBig":"styles_colBig__1iJR7","colSmall":"styles_colSmall__2bXer"};